import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QR_CODES_FEATURE_KEY } from '../keys';
import { QrCodesState } from '../reducers/qr-codes.reducer';

const selectState = createFeatureSelector<QrCodesState>(QR_CODES_FEATURE_KEY);

export const selectCache = createSelector(selectState, (state: QrCodesState) => state.cache);
export const selectPending = createSelector(selectState, (state: QrCodesState) => state.pending);
export const selectLoading = createSelector(selectPending, (pending) => pending.length > 0);
